import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

export const rateBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'directories',
    url: '/directories/stock'
  },
  {
    label: 'exchange_rates',
    active: true
  }
];

export type RateType = {
  base: string;
  main_currency: string;
  convertible: string;
  units: string;
  create_date: string;
  guid: string;
};
